import { Title } from '@components';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';
import { ReactNode } from 'react';

const TitleBox = styled(Box)`
  margin-bottom: 16px;
  ${breakpoints.up('md')} {
    margin-bottom: 32px;
  }

  .main-title {
  }
`;

const PageSubtitle = styled(Box)`
  font-weight: 600;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.01em;
  color: #1c1c1c;
  ${breakpoints.up('md')} {
    font-size: 24px;
    margin: 8px 0 0 2px;
  }
`;

// TYPES
//-------

export type PageTitleProps = {
  title?: string;
  subtitle?: string;
  logo?: ReactNode;
};

export const PageTitle = ({ title, subtitle }: PageTitleProps) => {
  return (
    <TitleBox>
      {title && <Title>{title}</Title>}
      {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
    </TitleBox>
  );
};
